import { API } from '@app/constants/api';
import axios from 'axios';
import { HsCodeSuggestionApiResponse, ItemCategoryApiResponse } from './types';

export const getItemCategories = async (): Promise<ItemCategoryApiResponse[]> =>
  (await axios.get(`${API.endpoint}/item_categories`))?.data?.item_categories || [];

export const getItemCategoryByName = async ({
  companyId,
  keyword,
  signal,
}: {
  companyId: string;
  keyword: string;
  signal?: AbortSignal;
}): Promise<HsCodeSuggestionApiResponse[]> =>
  (
    await axios.post(
      `${API.baseEndpoint}/v2/companies/${companyId}/hs_codes/hs_code_suggestions`,
      {
        keyword,
        keyword_search_field: 'name',
      },
      {
        signal,
      }
    )
  )?.data?.hs_codes || [];
